import * as PropTypes from 'prop-types';
import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var skeletonShapeClassName = 'ui-skeleton__shape';
/**
 * A SkeletonShape represents a shape (Image/Button/etc...) that will be loaded
 */

export var SkeletonShape = /*#__PURE__*/function () {
  var SkeletonShape = compose(Box, {
    className: skeletonShapeClassName,
    displayName: 'SkeletonShape',
    overrideStyles: true,
    shorthandConfig: {},
    handledProps: ['round', 'width', 'height'],
    mapPropsToStylesProps: function mapPropsToStylesProps(_ref) {
      var width = _ref.width,
          height = _ref.height,
          round = _ref.round;
      return {
        width: width,
        height: height,
        round: round
      };
    }
  });
  SkeletonShape.propTypes = Object.assign({}, commonPropTypes.createCommon(), {
    width: PropTypes.string,
    height: PropTypes.string,
    round: PropTypes.bool
  });
  SkeletonShape.defaultProps = {
    as: 'span',
    width: '100px',
    height: '100px',
    round: false
  };
  return SkeletonShape;
}();
//# sourceMappingURL=SkeletonShape.js.map
